<template lang="pug">
.request-obj
  .request-obj__media
    img(
      v-if="request.campshift.photos && request.campshift.photos[0]"
      v-bind:src="request.campshift.photos[0].preview_376x340"
    )
    img(
      v-else
      src="https://dummyimage.com/130x130/23695e/ffffff.jpg"
    )
  .request-obj__body
    .request-obj__main
      .request-obj__status
        .status(
        :class="requestOrders[request.status].value"
        ) {{ requestOrders[request.status]._text ? requestOrders[request.status]._text : requestOrders[request.status].text }}
        img.payed-status(
        v-if="!request.payed"
        src="@/assets/images/icons/payed-false.svg"
        )
        img.payed-status(
        v-else
        src="@/assets/images/icons/payed-true.svg"
        )
      .request-obj__name  {{ request.campshift.camp_name }}
      .request-obj__title {{ request.campshift.name }}
      .request-obj__date-container
        span.request-obj__date {{ request.campshift.date_started | monthDayDate }} - {{ request.campshift.date_finished | monthDayDate }}
        span.request-obj__days
      .request-obj__child-name {{ request.child.last_name }} {{ request.child.first_name }} {{ request.child.fathers_name }}
      .request-obj__points Количество баллов в заявке: {{ request.points }}
    .request-obj__side
      <!--.request-obj__request-date {{ request.date_created | simpleDate }}-->
      .request-obj__more(
      v-if="request.status !== 12"
      )
        .dots
          button.dots__button(
          @click.prevent="showMore = true"
          )
            span
          .dots__dropdown(
            v-if="showMore"
            @click="showMore = false"
          )
            ul.dropdown-menu
              li.dropdown-menu__item(
              v-if="request.status !== 12 && request.status !== 11"
              )
                a.dropdown-menu__link(
                @click.prevent.stop="onCancelOrder(request)"
                ) Отменить
              li.dropdown-menu__item(
              v-else-if="request.status === 11"
              )
                a.dropdown-menu__link(
                @click.prevent.stop="onClickDetails($event)"
                ) Детали
              li.dropdown-menu__item(
              v-if="request.status === 5"
              )
                a.dropdown-menu__link(
                @click.prevent.stop="onShowDetailsModal(request)"
                ) Детали
      .request-obj__button
        button.button.button_paint-main(
        v-if="request.quotashouse.quota_acquiring_enabled && request.status === 5 && !request.payed"
        @click.prevent="onGetPaymentUrl(request.id)"
        ) Оплатить
      .request-obj__details
        reason-for-cancellation(
          v-if="showReason"
          @close="closeReason"
          :request="request"
        )
</template>
<script>
import {mapState, mapActions} from "vuex";
import ReasonForCancellation from "./ReasonForCancellation";

export default {
  name: "RequestObj",
  components: {
    ReasonForCancellation
  },
  props: ["request", "ordersData", "onRemoveOrder"],
  data() {
    return {
      showReason: false,
      localOrdersData: this.ordersData,
      showMore: false
    };
  },
  computed: {
    ...mapState(["catalogue"]),
    requestOrders() {
      return this.$store.getters.requestOrders();
    }
  },
  methods: {
    ...mapActions(["changeOrderStatus", "getPaymentUrl"]),
    onCancelOrder(request) {
      if (request.status === 6) {
        this.$root.$emit("onShowConfirmModal", {
          text:
            "Для отмены заявки и возврата денежных средств обратитесь по телефону, указанному в  контактах лагеря или смены.",
          buttonConfirmFunc: {
            func: this.cancelOrder,
            params: [request]
          }
        });
        return false;
      } else {
        this.cancelOrder(request);
      }
    },
    cancelOrder(request) {
      this.changeOrderStatus({
        id: request.id,
        data: {
          status: 12
        }
      }).then(response => {
        if (response.status === 200) {
          this.onRemoveOrder(request);
        }
      });
    },
    closeReason: function() {
      this.showReason = false;
    },
    toggleReason() {
      this.showReason = !this.showReason;
    },
    onClickDetails(e, type) {
      if (this.showList) {
        this.toggleReason();
        return;
      }
      const _e = e;
      if (!type) {
        setTimeout(() => {
          this.onClickDetails(_e, "second");
        }, 0);
      } else {
        e.preventDefault();
        e.stopPropagation();
        this.toggleReason();
      }
    },
    onShowDetailsModal(request) {
      const deadline_date = new Date(
        request.date_originals_deadline
      ).toLocaleDateString("ru");
      let docs = "";
      request.docs.map(el => {
        docs += `<p><a href="${el.file}" class="link" target="_blank">-${
          el.name
        }</a></p>`;
        return el;
      });
      const address = JSON.parse(request.comment).comment;
      this.$root.$emit("onShowNotificationModal", {
        text: `Для получения путевки, Вам необходимо явиться с оригиналами документов и оплаченной квитанцией по адресу:
          ${address}<p>Крайняя дата подачи оригиналов: <strong>${deadline_date}</strong></p>
          ${docs}`,
        widthType: "big",
        textFloat: "left"
      });
    },
    onGetPaymentUrl(id) {
      this.getPaymentUrl(id).then(res => {
        console.log(res);
        window.open(res.url);
      });
    }
  }
};
</script>
